@if (model() && formGroup()) {
<div class="glossary">
    <div class="row">
        @if (model()?.headers && glossaryArray?.length) {
        <ng-container [formArray]="glossaryArray">
            @for (header of model()?.headers; track i; let i = $index) {
            <app-option [formGroup]="$any($safeNavigationMigration(glossaryArray.at(i)))" [model]="header" [meta]="meta()"
                (delete)="onDelete($event)"></app-option>
            }
        </ng-container>
        }
        <button [disabled]="!formGroup()?.valid" type="button" class="button" (click)="onAddField()">
            <mat-icon>add_box</mat-icon>
        </button>
    </div>
</div>
}
